export default {
  // Mining stats
  mining_maxDepth0: {
    achievement: '深不见底',
    description: '最大深度'
  },
  mining_maxDepth1: {
    achievement: '更深一层',
    description: '气态巨行星最大深度'
  },
  mining_maxDepthSpeedrun: {
    achievement: '速探深渊',
    description: '15分钟内达到最大深度'
  },
  mining_depthDwellerCap0: {
    achievement: '垂直钻探',
    description: '最大居民深度'
  },
  mining_depthDwellerCap1: {
    achievement: '无火花区',
    description: '最大气体居民深度'
  },
  mining_totalDamage: {
    achievement: '破坏之力',
    description: '造成的总伤害'
  },
  mining_maxDamage: {
    achievement: '强力一击',
    description: '单次最大伤害'
  },
  mining_craftingCount: {
    description: '制作的镐数量'
  },
  mining_scrap: {
    achievement: '废料堆',
    description: '获得的废料'
  },
  mining_oreTotal: {
    achievement: '矿石丰富',
    description: '获得的矿石总量'
  },
  mining_oreVariety: {
    achievement: '多样矿藏',
    description: '发现的矿石种类'
  },
  mining_coal: {
    achievement: '漆黑一片',
    description: '获得的煤炭量'
  },
  mining_coalMax: {
    description: '最高煤炭数量'
  },
  mining_resin: {
    achievement: '黏滞困境',
    description: '获得的树脂量'
  },
  mining_craftingWasted: {
    achievement: '徒劳无功',
    description: '制作了一把不如当前镐好的镐'
  },
  mining_dwellerCapHit: {
    achievement: '触底反弹',
    description: '达到最大居民深度'
  },
  mining_craftingLuck: {
    achievement: '百万分之一',
    description: '获得属性排名前0.0001%的镐'
  },
  mining_timeSpent: {
    description: '花费的时间'
  },
  mining_bestPrestige0: {
    description: '最佳声望（矿井）'
  },
  mining_bestPrestige1: {
    description: '最佳声望（气态巨行星）'
  },
  mining_prestigeCount: {
    description: '声望次数'
  },

  // Village stats
  village_maxBuilding: {
    achievement: '摩天大楼',
    description: '已建成的建筑数量'
  },
  village_basicResources: {
    achievement: '敲敲木头',
    description: '最高的木材、植物纤维或石料数量'
  },
  village_metal: {
    achievement: '金属与锈蚀',
    description: '最高金属数量'
  },
  village_coin: {
    achievement: '资本家',
    description: '获得的硬币'
  },
  village_water: {
    achievement: '水道系统',
    description: '最高水量'
  },
  village_knowledge: {
    achievement: '智多星',
    description: '最高知识数量'
  },
  village_advancedResources: {
    achievement: '闪闪发光',
    description: '最高的硬木或宝石数量'
  },
  village_blessing: {
    achievement: '命中注定',
    description: '获得的祝福'
  },
  village_offering: {
    achievement: '虚无主义者',
    description: '获得的供品'
  },
  village_sacrifice: {
    achievement: '黑洞',
    description: '做出的牺牲'
  },
  village_oil: {
    achievement: '夺取石油！',
    description: '最高石油数量'
  },
  village_highestPower: {
    achievement: '灯火通明',
    description: '最高电力'
  },
  village_minHappiness: {
    achievement: '地狱生活',
    description: '达到最低幸福感'
  },
  village_timeSpent: {
    description: '花费的时间'
  },
  village_bestPrestige0: {
    description: '最佳声望（工人）'
  },
  village_bestPrestige1: {
    description: '最佳声望（工匠公会）'
  },
  village_prestigeCount: {
    description: '声望次数'
  },
  village_offeringMax: {
    description: '最高供品数量'
  },

  // Horde stats
  horde_maxZone: {
    achievement: '探险家',
    description: '最高区域'
  },
  horde_maxDifficulty: {
    description: '最高难度'
  },
  horde_maxZoneSpeedrun: {
    achievement: '迅捷突袭',
    description: '30分钟内达到最高区域'
  },
  horde_totalDamage: {
    achievement: '屠魔者',
    description: '造成的基础攻击总伤害'
  },
  horde_maxDamage: {
    achievement: '所向披靡',
    description: '单次基础攻击最大伤害'
  },
  horde_bone: {
    achievement: '狗狗最爱',
    description: '获得的骨头'
  },
  horde_monsterPart: {
    achievement: '物尽其用',
    description: '获得的怪物部件'
  },
  horde_soulCorrupted: {
    achievement: '灵魂牧者',
    description: '获得的腐化灵魂'
  },
  horde_maxCorruptionKill: {
    achievement: '挑战邪恶',
    description: '击败最高腐化等级的敌人'
  },
  horde_maxMastery: {
    achievement: '一招制胜',
    description: '最高精通等级'
  },
  horde_totalMastery: {
    achievement: '多样化',
    description: '总精通等级'
  },
  horde_unlucky: {
    achievement: '倒霉透顶',
    description: '在99%几率下失败获取传家宝'
  },
  horde_maxItems: {
    description: '最多装备使用数量'
  },
  horde_timeSpent: {
    description: '花费的时间'
  },
  horde_bestPrestige0: {
    description: '最佳声望 (装备)'
  },
  horde_bestPrestige1: {
    description: '最佳声望 (职业)'
  },
  horde_prestigeCount: {
    description: '声望'
  },

  // Farm stats
  farm_harvests: {
    achievement: '割草机',
    description: '总收成'
  },
  farm_maxOvergrow: {
    achievement: '园丁',
    description: '最佳收获'
  },
  farm_bestPrestige: {
    achievement: '享有盛誉',
    description: '最高作物声望'
  },
  farm_vegetable: {
    achievement: '素食主义者',
    description: '获得的蔬菜'
  },
  farm_berry: {
    achievement: '浆果不错',
    description: '获得的浆果'
  },
  farm_grain: {
    achievement: '面包师',
    description: '获得的谷物'
  },
  farm_flower: {
    achievement: '花店老板',
    description: '获得的鲜花'
  },
  farm_gold: {
    achievement: '单片眼镜',
    description: '获得的黄金'
  },
  farm_bugMax: {
    description: '最高虫子数量'
  },
  farm_ladybugMax: {
    description: '最高瓢虫数量'
  },
  farm_butterflyMax: {
    description: '最奥蝴蝶数量'
  },
  farm_totalMystery: {
    description: '神秘'
  },

  // Gallery stats
  gallery_beauty: {
    achievement: '美丽',
    description: '获得的美丽'
  },
  gallery_converter: {
    achievement: '无限循环',
    description: '获得的转换器'
  },
  gallery_colorVariety: {
    achievement: '颜色多样性',
    description: '找到的颜色类型'
  },
  gallery_cash: {
    achievement: '富有',
    description: '获得的现金'
  },
  gallery_greenMax: {
    description: '在一次声望中达到的最高绿色涂料'
  },
  gallery_bestPrestige: {
    description: '一次声望中的最高现金'
  },
  gallery_highestTierIdea: {
    achievement: '脑洞大',
    description: '应用的最高层创意'
  },
  gallery_inspirationMax: {
    description: '最高灵感数量'
  },
  gallery_packageMax: {
    achievement: '纸板堡垒',
    description: '最高包包数量'
  },
  gallery_redDrumMax: {
    achievement: '笨蛋笨蛋笨蛋',
    description: '最高红鼓数量'
  },
  gallery_shapeComboTotal: {
    achievement: '收藏家',
    description: '收集的形状总数'
  },
  gallery_shapeComboHighest: {
    achievement: '天才',
    description: '最高形状组合'
  },
  gallery_canvasLevelTotal: {
    achievement: '远见卓识',
    description: '画布总等级'
  },
  gallery_hourglassHighest: {
    achievement: '借来的时间',
    description: '沙漏时间达到 1 天'
  },
  gallery_timeSpent: {
    description: '花费的时间'
  },
  gallery_prestigeCount: {
    description: '声望'
  },

  // Meta stats
  meta_totalLevel: {
    achievement: '优等生',
    description: '其他成就总等级'
  },
  meta_highestGrade: {
    achievement: '无所不知',
    description: '最好的学校成绩'
  },
  meta_longestOfflineTime: {
    achievement: '回来',
    description: '最长离线时长'
  }
};